/**
 * Shown while a sign-in claim waits on another tab that still has this browser's signed-out
 * projects open. Nothing has been moved yet; Retry claims again once that tab is closed.
 */
export function ClaimBlockedBanner({ onRetry }: { onRetry: () => void }) {
  return (
    <div
      role="alert"
      className="flex items-center justify-center gap-3 bg-amber-50 px-4 py-2 text-sm text-amber-900"
    >
      Your projects from before you signed in are still open in another RosaHouse tab. Close that
      tab, then retry to move them into your account.
      <button
        type="button"
        onClick={onRetry}
        className="rounded-lg bg-white px-3 py-1 font-medium text-amber-900 hover:bg-amber-100"
      >
        Retry
      </button>
    </div>
  );
}
